// Define role-based colors and styles for avatars
export type UserRole = 'parent' | 'teacher' | 'board';

const roleColors: Record<UserRole, { background: string; text: string }> = {
  parent: {
    background: 'bg-purple-500',
    text: 'text-white'
  },
  teacher: {
    background: 'bg-blue-500',
    text: 'text-white'
  },
  board: {
    background: 'bg-yellow-500',
    text: 'text-white'
  }
};

export function getRoleAvatarData(role: UserRole, name: string, email: string) {
  const colors = roleColors[role];
  const initials = getInitials(name);
  
  // Create a deterministic but varied avatar data based on role and user info
  const userHash = simpleHash(email || name);
  const avatarVariant = (userHash % 4) + 1; // 1-4 for subtle variations
  
  return {
    backgroundColor: colors.background,
    textColor: colors.text,
    initials,
    variant: avatarVariant,
    role
  };
}

export function getInitials(name: string): string {
  if (!name) return '?';
  
  const parts = name.trim().split(' ');
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function simpleHash(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}